import { atom } from '~/observers/jotai'

import { Authentication } from './types'

export const authenticationAtom = atom<Authentication | undefined>(undefined)
export const loadingAuthenticationAtom = atom<boolean>(true)
